module.exports = __webpack_public_path__ + "img/major-logo-hover.3e0e822d.png";